import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { CurrentUserResponse, fetchCurrentUser } from "@internal/auth/api";

export const currentUserQueryKey = ["auth", "me"] as const;

export function useCurrentUserQuery(): UseQueryResult<CurrentUserResponse, Error> {
  return useQuery({
    queryKey: currentUserQueryKey,
    queryFn: fetchCurrentUser,
    retry: false,
  });
}
